import logo from "../../assets/img/logo.png";
import { useEffect } from "react";
import useAuth from "../../authentication/useAuth";
import { useNavigate } from "react-router-dom";
export default function Header({ updater }) {
  const navigate = useNavigate();

  const { logout } = useAuth();
  function logoutUser() {
    logout();
    updater();
    navigate("/login");
  }
  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light py-0 bg-light">
        <div className="container-fluid">
          <img className="navbar-brand d-block d-lg-none p-0" src={logo} alt="logo" style={{ width: "100px", height: "100px" }} />
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon" />
          </button>
          <div className="collapse navbar-collapse ms-5" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <a className="nav-link active" aria-current="page" href="#">
                  لیست قرارداد ها
                </a>
              </li>
              <li className="nav-item">
                <div
                  className="nav-link"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    logoutUser();
                  }}
                >
                  خروج
                </div>
              </li>
            </ul>
            <div>
              <img className="navbar-brand d-none d-lg-block p-0" src={logo} alt="logo" style={{ width: "100px", height: "100px" }} />
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}
